var _style, _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeclarations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.8 31.9",
    style: {
      enableBackground: "new 0 0 26.8 31.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M25.6,4.4H5.2c-0.4,0-0.8,0.3-0.8,0.8v25.7c0,0.4,0.3,0.8,0.8,0.8h13c0.2,0,0.4-0.1,0.5-0.2l7.5-7.5 c0.1-0.1,0.2-0.3,0.2-0.5V5.2C26.4,4.8,26.1,4.4,25.6,4.4z M18.7,24h5.2l-5.2,5.2V24z M5.9,5.9h19v16.8h-6.8 c-0.3,0-0.6,0.3-0.6,0.6v6.8H5.9V5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M22.9,1c0-0.4-0.3-0.8-0.8-0.8H2.4c-1.1,0-2,0.9-2,2v25.7c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8V1.8 h20.2C22.5,1.8,22.9,1.4,22.9,1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M21.6,8.8H9.3C9,8.8,8.7,9,8.7,9.4S9,10,9.3,10h12.3c0.3,0,0.6-0.3,0.6-0.6S21.9,8.8,21.6,8.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M19.5,13.1H9.3c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h10.3c0.3,0,0.6-0.3,0.6-0.6S19.9,13.1,19.5,13.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M21.6,17.4H9.3c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h12.3c0.3,0,0.6-0.3,0.6-0.6S21.9,17.4,21.6,17.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclarations);
export default __webpack_public_path__ + "static/media/Declarations.3d3629a6.svg";
export { ForwardRef as ReactComponent };